export default function observeStore (store, select, onChange) {
  let currentState;

  function handleChange () {
    const state = store.getState();
    const nextState = select(state);

    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState, state);
    }
  }

  const unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
}
